export default [
  { key: '0', label: 'Workflow Name', type: 'text', name: 'workflowName', required: true},
  { key: '1', label: 'Instrument', type: 'select', name: 'instrument', required: true},
  { key: '2', label: 'Variant Caller', type: 'select',name: 'variantCaller',required: true },
  { key: '3', label: 'Reagent Kit', type: 'select', name: 'reagentKit', required: true },
  { key: '4', label: 'Patient ID', type: 'text', name: 'patientId', required: true},
  { key: '5', label: 'Specimen ID', type: 'text', name: 'specimenId', required: true},
  { key: '6', label: 'Patient Date Of Birth', type: 'datetime-local', name: 'patientDateOfBirth', required: false},
  { key: '7', label: 'Patient Race', type: 'select', name: "patientRace", required: false },
  { key: '8', label: 'Patient Ethnicity', type: 'select', name: 'patientEthnicity', required: false},
  { key: '9', label: 'Patient Sex', type: 'select', name: 'patientSex', required: false},
];
